export const AbrasiveData = [
    //maybe change to an array of address strings
    {
        image: '/images/product_images/molemab_images/molemab_tool/molemab_tool.jpg',
        height: '467px',
        width: '800px',
        link: '/products/molemab/tool_sharpening'
    },
    {
        image: '/images/product_images/molemab_images/molemab_internal/molemab_internal.jpg',
        height: '467px',
        width: '800px',
        link: '/products/molemab/internal'
    },
    {
        image: '/images/product_images/molemab_images/molemab_cbn/molemab_automotive_cbn.jpg',
        height: '467px',
        width: '800px',
        link: '/products/molemab/cbn'
    },
    {
        image: '/images/product_images/molemab_images/molemab_cbn/molemab_internal_cbn.jpg',
        height: '467px',
        width: '800px',
        link: '/products/molemab/cbn'
    },
    {
        image: '/images/product_images/molemab_images/molemab_burr/molemab_mounted.jpg',
        height: '467px',
        width: '800px',
        link: '/products/molemab/burr'
    },
    {
        image: '/images/product_images/darmann_images/darmann_type/darmann_superfinishing.jpg',
        height: '467px',
        width: '800px',
        link: '/products/darmann/superfinishing'
    },
    {
        image: '/images/product_images/darmann_images/darmann_type/darmann_flat.jpg',
        height: '467px',
        width: '800px',
        link: '/products/darmann/flat_finishing'
    },
    {
        image: '/images/product_images/darmann_images/darmann_type/darmann_precision.jpg',
        height: '467px',
        width: '800px',
        link: '/products/darmann/precision'
    },
]

export const ExtraData = [
    {
        image: '/images/product_images/extra_slider_images/innozl_5.jpg',
        height: '467px',
        width: '800px',
        link: '/products/innogrind/standard'
    },
    {
        image: '/images/product_images/extra_slider_images/innozl_2.jpg',
        height: '467px',
        width: '800px',
        link: '/products/innogrind/custom'
    },
    {
        image: '/images/product_images/extra_slider_images/innozl_3.jpg',
        height: '467px',
        width: '800px',
        link: '/products/innogrind/custom'
    },
    {
        image: '/images/product_images/extra_slider_images/innozl_4.jpg',
        height: '467px',
        width: '800px',
        link: '/products/innogrind/standard'
    },
    {
        image: '/images/product_images/hirtline_images/hirtline_type_images/hirtline_standard.jpg',
        height: '311px',
        width: '650px',
        link: '/products/hirtline/system_sizes'
    },
    {
        image: '/images/product_images/extra_slider_images/innozl_1.jpg',
        height: '311px',
        width: '650px',
        link: '/products/innogrind/custom'
    },
]

export const ExtraData_2 = [
    {
        image: '/images/product_images/gioria_images/gioria_type_images/gioria_r.jpg',
        height: '467px',
        width: '800px',
        link: '/products/gioria/rcnc'
    },
    {
        image: '/images/product_images/gioria_images/gioria_type_images/gioria_r_150.jpg',
        height: '467px',
        width: '800px',
        link: '/products/gioria/r150'
    },
    {
        image: '/images/product_images/gioria_images/gioria_type_images/gioria_r_152.jpg',
        height: '467px',
        width: '800px',
        link: '/products/gioria/r152'
    },
    {
        image: '/images/product_images/gioria_images/gioria_type_images/gioria_ru.jpg',
        height: '467px',
        width: '800px',
        link: '/products/gioria/rupncnc'
    },
    {
        image: '/images/product_images/gioria_images/gioria_type_images/gioria_r_154.jpg',
        height: '467px',
        width: '800px',
        link: '/products/gioria/r154'
    },
    {
        image: '/images/product_images/gioria_images/gioria_type_images/gioria_r_162.jpg',
        height: '467px',
        width: '800px',
        link: '/products/gioria/r162'
    },
    {
        image: '/images/product_images/gioria_images/gioria_type_images/gioria_r_163.jpg',
        height: '467px',
        width: '800px',
        link: '/products/gioria/r163'
    },
    {
        image: '/images/product_images/gioria_images/gioria_type_images/gioria_ru_s.jpg',
        height: '467px',
        width: '800px',
        link: '/products/gioria/ruscnc'
    },
]

export const ExtraData_3 = [
    {
        image: '/images/product_images/arc_images/arc_type_images/AR_AnloxRollr.jpg',
        height: '467px',
        width: '800px',
        
    },
    {
        image: '/images/product_images/arc_images/arc_type_images/gluerollWRDS.jpg',
        height: '467px',
        width: '800px'
    },
    {
        image: '/images/product_images/arc_images/arc_type_images/ARC_AnlxClnPad.jpg',
        height: '467px',
        width: '800px'
    },
]